import useSWR from 'swr';

export default class APIMe {

  getHeadersWithContentType(arg0: string | undefined): HeadersInit | undefined {
    throw new Error("Method not implemented.");
  }

  getURLSearchParams(object: any) {
    throw new Error("Method not implemented.");
  }

  fetcher(url: string) {
    throw new Error("Method not implemented.");
  }

  useMe() {
    const endpoint = `${process.env.NEXT_PUBLIC_API_URL}/api/me`
    const { data, error, isLoading, mutate } = useSWR(endpoint, this.fetcher, {
      revalidateOnFocus: false
    })

    return {
      data: data,
      error: error,
      isLoading: isLoading,
      mutate: mutate
    }
  }
}